import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionOneDto } from "./addition-type.dto";

export class AllvalueAdditionOneResponse extends GlobalResponseObject{

      data?: ValueAdditionOneDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionOneDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}